import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class MotifService {

  motifs: any[] = [];
  constructor(private http: HttpClient) {
    this.getMotif().subscribe((motifs: any[]) => {
      this.motifs = motifs;
    })
  }

  public getMotif() {
     return this.http.get(environment.api.motif);
  }
}



// WEBPACK FOOTER //
// ./src/app/service/MotifService.ts